export default "__VITE_ASSET__c6194ec3__"